import apiClient from '../../api/http-common';

const getSecurityOptions = () =>
  apiClient.post('/settings/security/get-options-data')

const getSecurityData = () =>
  apiClient.post('/settings/security/edit')

const updateSecurityData = (data) =>
  apiClient.post('/settings/security/update', data)

const forceChangePassword = (data) =>
  apiClient.post('/settings/security/force-password-reset', data)

const SecurityService = {
  getSecurityOptions,
  getSecurityData,
  updateSecurityData,
  forceChangePassword
};

export default SecurityService;
